module.exports = __webpack_public_path__ + "img/product-penjaminan-kredit-multiguna.984ca4bd.jpeg";